import { Log } from '@swyft/core';
import { UserManager, WebStorageStateStore } from 'oidc-client';
export class AuthService {
    userManager;
    permissions;
    config;
    constructor(config) {
        this.permissions = [];
        this.config = config;
        this.userManager = new UserManager({
            authority: config.authority,
            client_id: config.clientId,
            scope: 'openid profile api',
            response_type: 'code',
            automaticSilentRenew: false,
            redirect_uri: `${window.location.origin}${config.basePath}/signin-redirect`,
            silent_redirect_uri: `${window.location.origin}${config.basePath}/silent-renew.html`,
            post_logout_redirect_uri: `${window.location.origin}${config.basePath}/signout-redirect`,
            loadUserInfo: false,
            userStore: new WebStorageStateStore({ store: window.sessionStorage })
        });
        this.userManager.events.addUserLoaded(this.userLoaded);
        // Oidc Logger
        // Log.logger = console;
        // Log.level = Log.DEBUG;
    }
    userLoaded = (user) => {
        Log.info(`User Loaded: Session Expiry ${user.expires_in}s`);
        localStorage.setItem(this.StorageCheckAuth, 'true');
        this.permissions = this.getPermissionsFromAccessToken(user.access_token);
    };
    hasPermission = (permission) => {
        // Log.debug(`Check Permission: ${permission}`);
        return this.permissions.includes(permission);
    };
    signInRedirectCallback = async () => {
        Log.debug('AuthService:signInRedirectCallback');
        return await this.userManager.signinRedirectCallback().then((user) => {
            if (user.state) {
                this.config.handleRedirectCallbackState(user.state);
            }
            else {
                window.history.replaceState({}, document.title, window.location.pathname);
            }
        });
    };
    StorageCheckAuth = 'check_auth';
    getUser = async () => {
        // Log.debug("AuthService:getUser");
        var user = await this.userManager.getUser();
        if (user) {
            this.userLoaded(user);
        }
        else {
            this.permissions = [];
        }
        return user || undefined;
    };
    tryGetUser = async () => {
        // Log.debug("AuthService:tryGetUser");
        if (!localStorage.getItem(this.StorageCheckAuth)) {
            return;
        }
        var user = await this.getUser();
        if (!user || user.expired) {
            try {
                user = await this.signInSilent();
                // this.userLoaded(user);
            }
            catch (error) {
                return;
            }
        }
        return user;
    };
    signInRedirect = (path) => {
        path = path || window.location.pathname.substr(this.config.basePath.length);
        localStorage.setItem('redirectUri', window.location.pathname);
        this.userManager.signinRedirect({ state: path });
    };
    isAuthenticated = () => {
        const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${this.config.authority}:${this.config.clientId}`) || '{}');
        var authenticated = !!oidcStorage && !!oidcStorage.access_token;
        // Log.debug("AuthService:isAuthenticated", authenticated);
        return authenticated;
    };
    signInSilent = () => {
        // Log.debug("AuthService:signInSilent");
        return this.userManager.signinSilent();
    };
    signOut = () => {
        // Log.debug("AuthService:signOut");
        this.userManager.signoutRedirect({
            id_token_hint: localStorage.getItem('id_token')
        });
        this.userManager.clearStaleState();
    };
    signOutRedirectCallback = () => {
        // Log.debug("AuthService:signOutRedirectCallback");
        this.userManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
        });
        this.userManager.clearStaleState();
    };
    getPermissionsFromAccessToken = (token) => {
        // var payload: any = jwt.decode(token);
        var payload = this.parseJwt(token);
        return (payload && payload.permissions) || [];
    };
    parseJwt = (token) => {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    };
}
